module.exports = __webpack_public_path__ + "img/gears.3841dd57.png";